<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    :disabled="model.unidadeDisabled ? true : false"
                    value-field="id"
                />
            </rkm-col>
            <rkm-col cols="6">
                <rkm-form-select
                    label="Local de atendimento"
                    :options="infraestruturas"
                    :validations="validations.infraestruturaId"
                    textField="nome"
                    v-model="model.infraestruturaId"
                    :disabled="model.infraestruturaDisabled ? true : false"
                    valueField="id"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-col cols="12">
            <rkm-form-checkbox
                v-model="model.executante"
                inline
            >
                Executante
            </rkm-form-checkbox>

            <rkm-form-checkbox
                v-model="model.prestador"
                inline
            >
                Prestador
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-form>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { object, repository } from '@/mixins'
export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestruturaId: { required:true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let unidade = this.unidades.find(u => u.id === this.model.unidadeId)

                if (unidade && unidade.infraestruturas) {
                    if (!this.model.unidadeDisabled) {
                        this.getPrincipal(unidade.infraestruturas)
                    }
                    return unidade.infraestruturas
                }
            }

            return []
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameImagem.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        model: {
            id: null,
            unidadeId: null,
            unidadeDisabled: false,
            infraestruturaDisabled: false,
            executante: false,
            prestador: false,
            infraestruturaId: null,
            enviaSms: false,
            infraestruturaNome: '',
            sms: {
                diaAntecedencia: null,
                periodoEnvio: {
                    start: null,
                    end: null,
                },
                exames: []
            }
        },
        unidades: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.getUnidades()
                .then(({ data }) => {

                    this.unidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

            if (this.hasIndex) {

                const objId = this.data.model.unidades.findIndex((obj => obj.id == this.item.id));

                const data = this.data.model.unidades[objId]

                this.model.id = data.id
                this.model.unidadeId = data.unidadeId
                this.model.unidadeDisabled = data.unidadeId
                this.model.infraestruturaDisabled = data.infraestruturaId
                this.model.executante = data.executante
                this.model.prestador = data.prestador
                this.model.infraestruturaId = data.infraestruturaId
                this.model.infraestruturaNome = data.infraestruturaNome
                this.model.sms = data.sms
                this.model.enviaSms = data.enviaSms
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.model.infraestruturaId = localAtendimento.id
            } else {

                this.model.infraestruturaId = null
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.hasUnidadeParametrizada()) {

                            this.showValidationNotification("A unidade e/ou local de atendimento" +
                                " já foi inserida anteriormente.")
                            return
                        }

                        if (this.model.executante === false && this.model.prestador === false) {
                            this.showValidationNotification("É obrigatório informar se a unidade " +
                                "é executante e/ou prestador.")
                        }
                        else{

                            const unidade = this.unidades.find(u => u.id === this.model.unidadeId)
                            const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                            if (this.model.id == null) {

                                this.model.id = this.uniqueId('unidade' + new Date().getTime())
                            }

                            const param = {
                                id: this.model.id,
                                unidadeId: unidade.id,
                                nomeFantasia: unidade.nomeFantasia,
                                executante: this.model.executante,
                                prestador: this.model.prestador,
                                infraestruturaId: infraestrutura.id,
                                infraestruturaNome: infraestrutura.nome,
                                sms: this.model.sms,
                                enviaSms: this.model.executante ? this.model.enviaSms : false,
                            }

                            if (this.hasIndex) {

                                const objIndex = this.data.model.unidades.findIndex((obj => obj.id == this.model.id));

                                this.$set(this.data.model.unidades, objIndex, this.clone(param))
                            }
                            else {

                                this.data.model.unidades.push(this.clone(param))
                            }

                            const prestador = this.data.form.prestadores.find(prestador => prestador.unidadeId === unidade.id)

                            if  (prestador) {

                                const infra = prestador.infraestruturas.find(i => i.infraestruturaId === infraestrutura.id)

                                if (!infra && this.model.prestador === true) {

                                    prestador.infraestruturas.push({
                                        infraestruturaId: infraestrutura.id,
                                        infraestruturaNome: infraestrutura.nome,
                                        nomeFantasia: unidade.nomeFantasia,
                                        prestador: true,
                                        unidadeId: unidade.id,
                                        id: this.model.id
                                    })

                                }else{
                                    if (this.model.prestador === false){

                                        if(infra){
                                            prestador.infraestruturas.splice(prestador.infraestruturas.findIndex(
                                                p => p.infraestruturaId === infra.infraestruturaId
                                            ), 1)
                                        }
                                    }
                                }
                            }else{

                                let infraestruturas = []

                                if (this.model.prestador === true){
                                    infraestruturas.push({
                                        infraestruturaId: infraestrutura.id,
                                        infraestruturaNome: infraestrutura.nome,
                                        nomeFantasia: unidade.nomeFantasia,
                                        prestador: true,
                                        unidadeId: unidade.id,
                                        id: this.model.id
                                    })
                                }

                                this.data.form.prestadores.push({
                                    infraestruturas: infraestruturas,
                                    nomeFantasia: unidade.nomeFantasia,
                                    prestador: true,
                                    unidadeId: unidade.id,
                                    id: this.model.id
                                })
                            }

                            this.$emit('save', this.clone(param))
                        }
                })
        },
        hasUnidadeParametrizada() {

            return this.data.model.unidades.find((tipo) => tipo.id !== this.model.id
              && tipo.infraestruturaId == this.model.infraestruturaId
            )
        },
        resetSms(newValue) {

            this.model.executante = newValue

            this.model.sms.diaAntecedencia = null
            this.model.sms.periodoEnvio = {
                start: null,
                end: null,
            }
            this.model.sms.exames = []
        }
    },
    mixins: [object, repository],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
    watch: {
        'model.executante'(newValue, oldValue) {

            if (oldValue && this.model.sms && this.model.sms.diaAntecedencia) {

                this.showConfirmation(
                    `A unidade já possuí configurações de SMS parametrizadas e, ao continuar, essas
                        configurações serão perdidas. Deseja continuar?`,
                    async () => this.resetSms(newValue),
                    async () => this.model.executante = true,
                )
            }
        },
    }
}
</script>
